import { gql, useMutation } from '@apollo/client'
import styled from '@nobia/zeus-components/lib/styled'
import rem from '@nobia/zeus-components/lib/styled/rem'
import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'

import { CustomerSettingsFragment } from '../../graphql/CustomerFragments'
import { useTranslation } from '../../utils/useTranslation'
import { Switch } from '../form/Switch'
import InformationContainer from '../informationContainer/InformationContainer'

const CustomerUpdateSettingsMutation = gql`
  ${CustomerSettingsFragment}
  mutation UpdateSettings($input: CustomerSettingsInput) {
    customer {
      updateSettings(input: $input) {
        id
        settings {
          ...CustomerSettings
        }
      }
    }
  }
`

const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const SwitchLabel = styled.span`
  padding-right: ${rem(50)};
  font-size: ${rem(15)};
  flex-shrink: 1;
`

export const UserNotificationSettings = ({ settings }) => {
  const { t } = useTranslation('app.pages.user-settings.notifications')
  const [mutateCustomerSettings] = useMutation(CustomerUpdateSettingsMutation)

  const [
    messagingEmailNotificationEnabled,
    setMessagingEmailNotificationEnabled,
  ] = useState(settings?.messagingEmailNotificationEnabled)

  const handleMessagingEmailNotificationChange = useCallback(
    async (checked) => {
      setMessagingEmailNotificationEnabled(checked)
      const { data: updated } = await mutateCustomerSettings({
        variables: {
          input: {
            messagingEmailNotificationEnabled: checked,
          },
        },
      })
      setMessagingEmailNotificationEnabled(
        updated.customer.updateSettings.settings
          .messagingEmailNotificationEnabled
      )
    },
    [mutateCustomerSettings]
  )

  return (
    <InformationContainer title={t('heading')}>
      <SwitchWrapper>
        <SwitchLabel>{t('messaging-email-notifications')}</SwitchLabel>
        <Switch
          id="messaging-email-notification"
          checked={messagingEmailNotificationEnabled}
          onChange={handleMessagingEmailNotificationChange}
        />
      </SwitchWrapper>
    </InformationContainer>
  )
}

UserNotificationSettings.defaultProps = {
  settings: null,
}

UserNotificationSettings.propTypes = {
  settings: PropTypes.shape({
    messagingEmailNotificationEnabled: PropTypes.bool,
  }),
}
